<template>
  <v-table fixed-header height="300px">
    <thead>
      <tr v-if="attributes.length !== 0">
        <th
          v-for="attr in attributes.filter((key) => key !== 'state')"
          :key="attr"
        >
          <strong
            >{{ StringManipulation.methods.clearAndCapitalize(attr) }}
          </strong>
        </th>
        <th>Actions</th>
      </tr>
      <tr v-else>
        <th>No items have been created</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="item in items" :key="item.id">
        <td
          v-for="attr in attributes.filter((key) => key !== 'state')"
          v-if="item['state']"
        >
          {{ beautifyContent(item[attr]) }}
        </td>
        <td
          v-for="attr in attributes.filter((key) => key !== 'state')"
          v-else-if="item['state'] === false"
          style="background: rgba(255, 162, 162, 0.68)"
        >
          {{ beautifyContent(item[attr]) }}
        </td>
        <td v-for="attr in attributes.filter((key) => key !== 'state')" v-else>
          {{ beautifyContent(item[attr]) }}
        </td>

        <td v-if="item['state']">
          <Link :href="getShowUrl(item.id)" class="text-light-green-darken-4"
            >Open</Link
          >
          |
          <Link
            :href="getEditUrl(item.id)"
            text="Edit"
            class="text-light-blue-darken-4"
            >Edit</Link
          >
          |
          <a href="#" @click="onIndicatorDelete(item.id)" class="text-red"
            >Remove</a
          >
        </td>
        <td
          v-else-if="item['state'] === false"
          style="background: rgba(255, 162, 162, 0.68)"
        >
          <Link :href="getShowUrl(item.id)">Open</Link> |
          <Link :href="getEditUrl(item.id)" text="Edit">Edit</Link> |
          <a href="#" @click="onIndicatorDelete(item.id)" class="text-orange"
            >Remove</a
          >
        </td>
        <td v-else>
          <Link :href="getShowUrl(item.id)">Open</Link> |
          <Link :href="getEditUrl(item.id)" text="Edit">Edit</Link> |
          <a href="#" @click="onIndicatorDelete(item.id)" class="text-orange"
            >Remove</a
          >
        </td>
      </tr>
    </tbody>
  </v-table>
</template>

<script setup>
import { Link } from "@inertiajs/vue3";
// https://ipocs.co/article/how-to-register-and-use-global-properties-in-vuejs-3
import { router } from "@inertiajs/vue3";
import * as $routes from "@/packs/routes";
import StringManipulation from "../../../Mixins/StringManipulation";
import { onMounted, ref } from "vue";

const props = defineProps({
  projectId: {
    type: Number,
    required: true,
  },
  indicatorType: {
    type: String,
    required: true,
  },
  headers: {
    type: Array,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  color: {
    type: String,
    required: false,
  },
});

const attributes = ref([]);

onMounted(() => {
  if (props.items.length === 0) {
    attributes.value;
  } else {
    attributes.value = Object.keys(props.items[0]);
  }
});

function getHeaderClass() {
  switch (this.color) {
    case "sand":
      return "sand-header-table";
    case "dark":
      return "dark-header-table";
  }
}

// This is used to clear and capitalize strings or join arrays etc
function beautifyContent(content) {
  if (typeof content === "string")
    return StringManipulation.methods.clearAndCapitalize(content);
  else if (Array.isArray(content))
    // return content.map(e => StringManipulation.methods.clearAndCapitalize(e)).join(', ')
    return content.join(", ");
  else return content;
}

function getShowUrl(indicatorId) {
  switch (props.indicatorType) {
    case "kpi":
      return $routes.project_kpi(props.projectId, indicatorId);
    case "psi":
      return $routes.project_psi(props.projectId, indicatorId);
  }
}

function getEditUrl(indicatorId) {
  switch (props.indicatorType) {
    case "kpi":
      return $routes.edit_project_kpi(props.projectId, indicatorId);
    case "psi":
      return $routes.edit_project_psi(props.projectId, indicatorId);
  }
}

function onIndicatorDelete(indicatorId) {
  switch (props.indicatorType) {
    case "kpi":
      router.delete($routes.project_kpi(props.projectId, indicatorId), {
        onBefore: () => confirm("Are you sure you want to delete this KPI?"),
      });
      break;
    case "psi":
      router.delete($routes.project_psi(props.projectId, indicatorId), {
        onBefore: () => confirm("Are you sure you want to delete this PSI?"),
      });
      break;
  }
}
</script>
<style scoped>
a:hover {
  background: none;
  color: inherit;
}
</style>
